import * as React from 'react';
const SvgNetlify = (props) => (
  <svg viewBox="0 0 81 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M21.672 57.35h-.76l-3.781-3.68v-.74l5.776-5.622h4.003l.532.519v3.895l-5.776 5.622.006.005ZM17.13 15.74V15l3.782-3.68h.76l5.776 5.623v3.895l-.533.518h-4.002l-5.776-5.622-.006.006Z"
      fill="#05BDBA"
    />
    <path
      d="M50.406 45.488h-5.498l-.46-.447V32.51c0-2.228-.9-3.955-3.661-4.016-1.423-.038-3.05 0-4.785.067l-.26.259v16.214l-.46.447h-5.498l-.46-.447v-21.4l.46-.447h12.374c4.807 0 8.708 3.796 8.708 8.474v13.379l-.46.447Z"
      fill="#014847"
    />
    <path
      d="M22.454 37.466H.459L0 37.02v-5.362l.46-.447h21.994l.459.447v5.362l-.46.447ZM79.737 37.466H57.742l-.46-.447v-5.362l.46-.447h21.995l.459.447v5.362l-.46.447ZM36.926 16.501V.447l.46-.447h5.51l.459.447V16.5l-.46.447h-5.51l-.459-.447ZM36.926 68.229V52.174l.46-.446h5.51l.459.446V68.23l-.46.447h-5.51l-.459-.447Z"
      fill="#05BDBA"
    />
  </svg>
);
export default SvgNetlify;
